import { render, staticRenderFns } from "./category-browse.vue?vue&type=template&id=c6247c2a&scoped=true&"
import script from "./category-browse.vue?vue&type=script&lang=js&"
export * from "./category-browse.vue?vue&type=script&lang=js&"
import style0 from "./category-browse.vue?vue&type=style&index=0&id=c6247c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6247c2a",
  null
  
)

export default component.exports